// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 350px;
  height: 100vh;
  position: sticky;
  top: 0;
  border-right: 1px solid var(--border-color);
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  display: none;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
}

.sidebar .sidebar-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
  transition: background-color 0.2s;
}

.sidebar-close-btn:hover {
  background: var(--hover-bg);
}

.sidebar-close-btn svg {
  width: 24px;
  height: 24px;
}

/* Expand/collapse toggle — only visible at 769px–1024px via media query */
.sidebar-toggle-btn {
  display: none;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  width: 100%;
  height: 44px;
  border-radius: unset;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.sidebar.expanded .sidebar-toggle-btn {
  justify-content: flex-start;
  padding-left: 24px;
}

.sidebar-toggle-btn:hover {
  background: var(--hover-bg);
}

/* Backdrop — element is only in the DOM when expanded (conditional rendering in JS) */

.sidebar-content {
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Navigation */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  text-decoration: none;
  transition: background-color 0.2s;
}

.nav-item:hover {
  background-color: var(--hover-bg);
}

.nav-item.active {
  font-weight: 700;
  background-color: var(--hover-bg-strong);
  color: var(--text-primary);
}

.nav-item.active .nav-icon {
  stroke-width: 2.5;
}

.nav-icon {
  width: 24px;
  height: 24px;
  color: var(--text-primary);
}

/* Create Post Button */
.create-post-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 24px !important;
  margin-top: 8px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 24px !important;
  font-size: 16px !important;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
}

.create-post-btn:hover {
  background: var(--primary-hover);
}

.btn-icon {
  width: 20px;
  height: 20px;
}

.create-post-dropdown {
  position: relative;
  width: 100%;
}

.create-post-menu {
  position: absolute;
  z-index: 20;
  top: calc(100% + 8px);
  right: 0;
  width: 100%;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.create-post-menu-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

.create-post-menu-item:hover {
  background: var(--hover-bg);
}

/* Sidebar Widget */
.sidebar-widget {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 16px;
  margin-top: 8px;
}

.widget-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 12px 0;
}

.community-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Feed Selector List */
.feed-selector-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.feed-selector-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  text-decoration: none;
  transition: background-color 0.2s;
  cursor: pointer;
}

.feed-selector-item:hover {
  background: var(--hover-bg);
}

.feed-selector-item.active {
  background: var(--primary-color);
}

.feed-selector-item.active .feed-label {
  color: white;
  font-weight: 600;
}

.feed-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.community-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  text-decoration: none;
  transition: background-color 0.2s;
}

.community-item:hover {
  background: var(--hover-bg);
}

.community-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.community-subs {
  font-size: 12px;
  color: var(--text-secondary);
}

/* Responsive Design */
@media (max-width: 1299.9px) {
  .sidebar {
    width: 280px;
  }
}

@media (max-width: 1159.9px) {
  .sidebar {
    width: unset;
  }
}

@media (max-width: 1024px) {
  .sidebar {
    width: 88px;
  }

  .sidebar-content {
    padding: 20px 8px;
  }

  .nav-item span,
  .create-post-btn span {
    display: none;
  }

  .nav-item {
    justify-content: center;
    padding: 12px;
  }

  .create-post-btn {
    padding: 12px;
  }

  .sidebar-widget {
    display: none;
  }
}

/* ── 88px expand/collapse behaviour (769px–1024px only) ── */
@media (min-width: 769px) and (max-width: 1024px) {

  /* Show header bar with the toggle button */
  .sidebar .sidebar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }

  /* Hide the mobile-only close button in this range */
  .sidebar .sidebar-close-btn {
    display: none;
  }

  .sidebar-toggle-btn {
    display: flex;
  }

  /* ── Expanded overlay state ── */
  /* Base sidebar-inner: fill the 88px shell normally */
  .sidebar-inner {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
  }

  /* Shell stays 88px in flex flow; z-index creates the stacking context anchor */
  .sidebar.expanded {
    overflow: visible;
    z-index: 2000;
  }

  /* Inner panel: absolutely positioned inside the aside's stacking context */
  .sidebar.expanded .sidebar-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 350px;
    height: 100vh;
    background: var(--bg-primary);
    border-right: 1px solid var(--border-color);
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .sidebar.expanded .sidebar-header {
    justify-content: flex-start;
    padding: 8px 12px;
  }

  .sidebar.expanded .sidebar-content {
    padding: 20px 12px;
  }

  .sidebar.expanded .nav-item {
    justify-content: flex-start;
    padding: 12px 16px;
  }

  .sidebar.expanded .nav-item span,
  .sidebar.expanded .create-post-btn span {
    display: inline;
  }

  .sidebar.expanded .create-post-btn {
    padding: 14px 24px;
  }

  .sidebar.expanded .sidebar-widget {
    display: block;
  }

  /* Backdrop behind the expanded sidebar */
  .sidebar-expanded-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 1999;
  }
}

@media (max-width: 768px) {
  .sidebar {
    display: flex;
    width: 350px;
    background: var(--bg-primary);
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }

  .sidebar-header {
    display: flex;
  }

  .sidebar-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px 12px;
  }

  .nav-item span,
  .create-post-btn span {
    display: inline;
  }

  .nav-item {
    justify-content: flex-start;
    padding: 12px 16px;
  }

  .create-post-btn {
    padding: 14px 24px;
  }

  .sidebar-widget {
    display: block;
  }
}

/* ── Article workspace submenu ─────────────────────────── */
.nav-submenu-group {
  margin: 0;
  padding: 0;
}

.nav-submenu-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 16px 6px 48px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  transition: color 0.15s;
}

.nav-submenu-toggle:hover {
  color: var(--text-primary);
}

.submenu-chevron {
  transition: transform 0.18s;
  flex-shrink: 0;
}

.submenu-chevron.open {
  transform: rotate(180deg);
}

.nav-submenu {
  display: flex;
  flex-direction: column;
  padding: 2px 0 4px 48px;
}

.nav-subitem {
  padding: 7px 12px;
  font-size: 0.88rem;
  color: var(--text-secondary);
  text-decoration: none;
  border-radius: 5px;
  transition: color 0.15s, background 0.15s;
}

.nav-subitem:hover {
  color: var(--text-primary);
  background: var(--hover-bg);
  text-decoration: none;
}

.nav-subitem.active {
  color: var(--accent-primary);
  background: var(--hover-bg);
  font-weight: 600;
}

.nav-subitem.nav-subitem-create {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  text-align: left;
  border: none;
  background: transparent;
  width: 100%;
  cursor: pointer;
  color: var(--accent-primary);
  font-weight: 600;
  border-top: 1px solid var(--border-color);
  border-radius: 0 0 5px 5px;
  margin-top: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.nav-subitem.nav-subitem-create:hover {
  color: var(--accent-hover);
  background: var(--hover-background, rgba(29, 161, 242, 0.1));
}

/* Abbreviation spans — hidden by default, shown only in 88px icon mode */
.nav-subitem-abbr {
  display: none;
}

/* Icon-only sidebar: workspace submenu shows abbreviated first letters */
@media (max-width: 1024px) {
  .nav-submenu-group {
    display: block;
  }
}

/* Mobile drawer: restore and style for full-width touch use */
@media (max-width: 768px) {
  .nav-submenu-group {
    display: block;
  }
}

/* Expanded overlay: restore workspace submenu */
@media (min-width: 769px) and (max-width: 1024px) {

  /* Non-expanded (88px icon mode): abbreviated submenu */
  .sidebar:not(.expanded) .nav-submenu-toggle {
    justify-content: center;
    padding: 6px;
  }

  .sidebar:not(.expanded) .submenu-chevron {
    display: none;
  }

  .sidebar:not(.expanded) .nav-subitem-full {
    display: none;
  }

  .sidebar:not(.expanded) .nav-subitem-abbr {
    display: block;
  }

  .sidebar:not(.expanded) .nav-submenu {
    padding: 2px 0;
  }

  .sidebar:not(.expanded) .nav-subitem {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 4px;
  }

  /* Expanded overlay: restore full submenu text */
  .sidebar.expanded .nav-submenu-group {
    display: block;
  }

  .sidebar.expanded .nav-submenu-toggle {
    padding: 10px 16px;
    font-size: 0.82rem;
  }

  .sidebar.expanded .submenu-chevron {
    display: inline;
  }

  .sidebar.expanded .nav-subitem-full {
    display: block;
  }

  .sidebar.expanded .nav-subitem-abbr {
    display: none;
  }

  .sidebar.expanded .nav-submenu {
    padding: 2px 0 6px 16px;
  }

  .sidebar.expanded .nav-subitem {
    display: block;
    padding: 11px 16px;
    font-size: 0.95rem;
    border-radius: 8px;
  }
}

/* (mobile drawer submenu styles continue below) */
@media (max-width: 768px) {
  .nav-submenu-group {
    display: block;
  }

  .nav-submenu-toggle {
    padding: 10px 16px 10px 16px;
    font-size: 0.82rem;
  }

  /* Mobile drawer: restore full text, hide abbreviations */
  .nav-subitem-full {
    display: block;
  }

  .nav-subitem-abbr {
    display: none;
  }

  .submenu-chevron {
    display: inline;
  }

  .nav-submenu {
    padding: 2px 0 6px 16px;
  }

  .nav-subitem {
    display: block;
    padding: 11px 16px;
    font-size: 0.95rem;
    border-radius: 8px;
  }
}

/* ── Flex expandable nav item ─────────────────────────── */
.nav-item-group {
  display: flex;
  flex-direction: column;
}

.nav-item.nav-item-expandable {
  display: flex;
  align-items: center;
  padding: 0;
  gap: 0;
}

.nav-item-expandable .nav-item-link {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 8px 12px 16px;
  flex: 1 1;
  min-width: 0;
  text-decoration: none;
  color: inherit;
  border-radius: 24px 0 0 24px;
  transition: background-color 0.2s;
}

.nav-item-expandable .nav-item-link:hover {
  background-color: var(--hover-bg);
}

.nav-item-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  padding: 12px 10px 12px 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  border-radius: 0 24px 24px 0;
  transition: background-color 0.2s, color 0.15s;
  flex-shrink: 0;
}

.nav-item-chevron:hover {
  background-color: var(--hover-bg);
  color: var(--text-primary);
}

/* Flex submenu feeds list */
.nav-item-group .nav-submenu {
  padding-left: 40px;
}

.nav-subitem-lists-wrapper {
  display: flex;
  flex-direction: column;
}

.nav-subitem-lists-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
}

.nav-submenu-nested {
  padding-left: 12px;
}

.nav-subitem-count {
  margin-left: auto;
  font-size: 0.75rem;
  color: var(--text-secondary);
  opacity: 0.7;
}

/* 88px collapsed: hide chevron and submenu text */
@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar:not(.expanded) .nav-item-chevron {
    display: none;
  }

  .sidebar:not(.expanded) .nav-item-expandable .nav-item-link {
    justify-content: center;
    padding: 12px;
    border-radius: 24px;
  }

  .nav-item-expandable a.nav-item-link {
    padding: 0;
  }

  .sidebar:not(.expanded) .nav-item-expandable .nav-item-link span {
    display: none;
  }

  .sidebar:not(.expanded) .nav-item-group .nav-submenu {
    display: none;
  }
}

/* Expanded overlay: restore */
@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar.expanded .nav-item-chevron {
    display: flex;
  }

  .sidebar.expanded .nav-item-expandable .nav-item-link span {
    display: inline;
  }

  .sidebar.expanded .nav-item-group .nav-submenu {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sFAAsF;;AAEtF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6DAA6D;AAC7D;;EAEE,2CAA2C;EAC3C;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA,oDAAoD;EACpD;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,iCAAiC;EACjC,qDAAqD;EACrD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA,+EAA+E;EAC/E;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA,2EAA2E;EAC3E;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,2CAA2C;IAC3C,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA,yCAAyC;EACzC;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,6DAA6D;AAC7D;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA,yEAAyE;AACzE;EACE,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE;IACE,cAAc;EAChB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,cAAc;EAChB;AACF;;AAEA,gDAAgD;AAChD;;EAEE,uDAAuD;EACvD;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA,yDAAyD;EACzD;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,SAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,4BAA4B;EAC5B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".sidebar {\r\n  width: 350px;\r\n  height: 100vh;\r\n  position: sticky;\r\n  top: 0;\r\n  border-right: 1px solid var(--border-color);\r\n  overflow-y: auto;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sidebar-header {\r\n  display: none;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.sidebar .sidebar-close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  width: 100%;\r\n  height: 44px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.sidebar-close-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.sidebar-close-btn svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n/* Expand/collapse toggle — only visible at 769px–1024px via media query */\r\n.sidebar-toggle-btn {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: unset;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar.expanded .sidebar-toggle-btn {\r\n  justify-content: flex-start;\r\n  padding-left: 24px;\r\n}\r\n\r\n.sidebar-toggle-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n/* Backdrop — element is only in the DOM when expanded (conditional rendering in JS) */\r\n\r\n.sidebar-content {\r\n  padding: 20px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n/* Navigation */\r\n.sidebar-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 12px 16px;\r\n  border-radius: 24px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.nav-item:hover {\r\n  background-color: var(--hover-bg);\r\n}\r\n\r\n.nav-item.active {\r\n  font-weight: 700;\r\n  background-color: var(--hover-bg-strong);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.nav-item.active .nav-icon {\r\n  stroke-width: 2.5;\r\n}\r\n\r\n.nav-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Create Post Button */\r\n.create-post-btn {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 14px 24px !important;\r\n  margin-top: 8px;\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 24px !important;\r\n  font-size: 16px !important;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.create-post-btn:hover {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.btn-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.create-post-dropdown {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.create-post-menu {\r\n  position: absolute;\r\n  z-index: 20;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  width: 100%;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\r\n  overflow: hidden;\r\n}\r\n\r\n.create-post-menu-item {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 10px 14px;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n\r\n.create-post-menu-item:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n/* Sidebar Widget */\r\n.sidebar-widget {\r\n  background: var(--bg-secondary);\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.widget-title {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 12px 0;\r\n}\r\n\r\n.community-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n/* Feed Selector List */\r\n.feed-selector-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.feed-selector-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  transition: background-color 0.2s;\r\n  cursor: pointer;\r\n}\r\n\r\n.feed-selector-item:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.feed-selector-item.active {\r\n  background: var(--primary-color);\r\n}\r\n\r\n.feed-selector-item.active .feed-label {\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n\r\n.feed-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.community-item:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.community-name {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-subs {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1299.9px) {\r\n  .sidebar {\r\n    width: 280px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1159.9px) {\r\n  .sidebar {\r\n    width: unset;\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .sidebar {\r\n    width: 88px;\r\n  }\r\n\r\n  .sidebar-content {\r\n    padding: 20px 8px;\r\n  }\r\n\r\n  .nav-item span,\r\n  .create-post-btn span {\r\n    display: none;\r\n  }\r\n\r\n  .nav-item {\r\n    justify-content: center;\r\n    padding: 12px;\r\n  }\r\n\r\n  .create-post-btn {\r\n    padding: 12px;\r\n  }\r\n\r\n  .sidebar-widget {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* ── 88px expand/collapse behaviour (769px–1024px only) ── */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n\r\n  /* Show header bar with the toggle button */\r\n  .sidebar .sidebar-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px;\r\n  }\r\n\r\n  /* Hide the mobile-only close button in this range */\r\n  .sidebar .sidebar-close-btn {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar-toggle-btn {\r\n    display: flex;\r\n  }\r\n\r\n  /* ── Expanded overlay state ── */\r\n  /* Base sidebar-inner: fill the 88px shell normally */\r\n  .sidebar-inner {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  /* Shell stays 88px in flex flow; z-index creates the stacking context anchor */\r\n  .sidebar.expanded {\r\n    overflow: visible;\r\n    z-index: 2000;\r\n  }\r\n\r\n  /* Inner panel: absolutely positioned inside the aside's stacking context */\r\n  .sidebar.expanded .sidebar-inner {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 350px;\r\n    height: 100vh;\r\n    background: var(--bg-primary);\r\n    border-right: 1px solid var(--border-color);\r\n    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .sidebar.expanded .sidebar-header {\r\n    justify-content: flex-start;\r\n    padding: 8px 12px;\r\n  }\r\n\r\n  .sidebar.expanded .sidebar-content {\r\n    padding: 20px 12px;\r\n  }\r\n\r\n  .sidebar.expanded .nav-item {\r\n    justify-content: flex-start;\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .sidebar.expanded .nav-item span,\r\n  .sidebar.expanded .create-post-btn span {\r\n    display: inline;\r\n  }\r\n\r\n  .sidebar.expanded .create-post-btn {\r\n    padding: 14px 24px;\r\n  }\r\n\r\n  .sidebar.expanded .sidebar-widget {\r\n    display: block;\r\n  }\r\n\r\n  /* Backdrop behind the expanded sidebar */\r\n  .sidebar-expanded-backdrop {\r\n    display: block;\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.25);\r\n    z-index: 1999;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .sidebar {\r\n    display: flex;\r\n    width: 350px;\r\n    background: var(--bg-primary);\r\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .sidebar-header {\r\n    display: flex;\r\n  }\r\n\r\n  .sidebar-content {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 20px 12px;\r\n  }\r\n\r\n  .nav-item span,\r\n  .create-post-btn span {\r\n    display: inline;\r\n  }\r\n\r\n  .nav-item {\r\n    justify-content: flex-start;\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .create-post-btn {\r\n    padding: 14px 24px;\r\n  }\r\n\r\n  .sidebar-widget {\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* ── Article workspace submenu ─────────────────────────── */\r\n.nav-submenu-group {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.nav-submenu-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 6px 16px 6px 48px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  transition: color 0.15s;\r\n}\r\n\r\n.nav-submenu-toggle:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.submenu-chevron {\r\n  transition: transform 0.18s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.submenu-chevron.open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.nav-submenu {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 2px 0 4px 48px;\r\n}\r\n\r\n.nav-subitem {\r\n  padding: 7px 12px;\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary);\r\n  text-decoration: none;\r\n  border-radius: 5px;\r\n  transition: color 0.15s, background 0.15s;\r\n}\r\n\r\n.nav-subitem:hover {\r\n  color: var(--text-primary);\r\n  background: var(--hover-bg);\r\n  text-decoration: none;\r\n}\r\n\r\n.nav-subitem.active {\r\n  color: var(--accent-primary);\r\n  background: var(--hover-bg);\r\n  font-weight: 600;\r\n}\r\n\r\n.nav-subitem.nav-subitem-create {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  justify-content: flex-start;\r\n  text-align: left;\r\n  border: none;\r\n  background: transparent;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n  border-top: 1px solid var(--border-color);\r\n  border-radius: 0 0 5px 5px;\r\n  margin-top: 4px;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.nav-subitem.nav-subitem-create:hover {\r\n  color: var(--accent-hover);\r\n  background: var(--hover-background, rgba(29, 161, 242, 0.1));\r\n}\r\n\r\n/* Abbreviation spans — hidden by default, shown only in 88px icon mode */\r\n.nav-subitem-abbr {\r\n  display: none;\r\n}\r\n\r\n/* Icon-only sidebar: workspace submenu shows abbreviated first letters */\r\n@media (max-width: 1024px) {\r\n  .nav-submenu-group {\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* Mobile drawer: restore and style for full-width touch use */\r\n@media (max-width: 768px) {\r\n  .nav-submenu-group {\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* Expanded overlay: restore workspace submenu */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n\r\n  /* Non-expanded (88px icon mode): abbreviated submenu */\r\n  .sidebar:not(.expanded) .nav-submenu-toggle {\r\n    justify-content: center;\r\n    padding: 6px;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .submenu-chevron {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-subitem-full {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-subitem-abbr {\r\n    display: block;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-submenu {\r\n    padding: 2px 0;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-subitem {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 6px 4px;\r\n  }\r\n\r\n  /* Expanded overlay: restore full submenu text */\r\n  .sidebar.expanded .nav-submenu-group {\r\n    display: block;\r\n  }\r\n\r\n  .sidebar.expanded .nav-submenu-toggle {\r\n    padding: 10px 16px;\r\n    font-size: 0.82rem;\r\n  }\r\n\r\n  .sidebar.expanded .submenu-chevron {\r\n    display: inline;\r\n  }\r\n\r\n  .sidebar.expanded .nav-subitem-full {\r\n    display: block;\r\n  }\r\n\r\n  .sidebar.expanded .nav-subitem-abbr {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar.expanded .nav-submenu {\r\n    padding: 2px 0 6px 16px;\r\n  }\r\n\r\n  .sidebar.expanded .nav-subitem {\r\n    display: block;\r\n    padding: 11px 16px;\r\n    font-size: 0.95rem;\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n/* (mobile drawer submenu styles continue below) */\r\n@media (max-width: 768px) {\r\n  .nav-submenu-group {\r\n    display: block;\r\n  }\r\n\r\n  .nav-submenu-toggle {\r\n    padding: 10px 16px 10px 16px;\r\n    font-size: 0.82rem;\r\n  }\r\n\r\n  /* Mobile drawer: restore full text, hide abbreviations */\r\n  .nav-subitem-full {\r\n    display: block;\r\n  }\r\n\r\n  .nav-subitem-abbr {\r\n    display: none;\r\n  }\r\n\r\n  .submenu-chevron {\r\n    display: inline;\r\n  }\r\n\r\n  .nav-submenu {\r\n    padding: 2px 0 6px 16px;\r\n  }\r\n\r\n  .nav-subitem {\r\n    display: block;\r\n    padding: 11px 16px;\r\n    font-size: 0.95rem;\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n/* ── Flex expandable nav item ─────────────────────────── */\r\n.nav-item-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.nav-item.nav-item-expandable {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0;\r\n  gap: 0;\r\n}\r\n\r\n.nav-item-expandable .nav-item-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 12px 8px 12px 16px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  border-radius: 24px 0 0 24px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.nav-item-expandable .nav-item-link:hover {\r\n  background-color: var(--hover-bg);\r\n}\r\n\r\n.nav-item-chevron {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  padding: 12px 10px 12px 4px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  border-radius: 0 24px 24px 0;\r\n  transition: background-color 0.2s, color 0.15s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.nav-item-chevron:hover {\r\n  background-color: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Flex submenu feeds list */\r\n.nav-item-group .nav-submenu {\r\n  padding-left: 40px;\r\n}\r\n\r\n.nav-subitem-lists-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.nav-subitem-lists-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-submenu-nested {\r\n  padding-left: 12px;\r\n}\r\n\r\n.nav-subitem-count {\r\n  margin-left: auto;\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  opacity: 0.7;\r\n}\r\n\r\n/* 88px collapsed: hide chevron and submenu text */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .sidebar:not(.expanded) .nav-item-chevron {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-item-expandable .nav-item-link {\r\n    justify-content: center;\r\n    padding: 12px;\r\n    border-radius: 24px;\r\n  }\r\n\r\n  .nav-item-expandable a.nav-item-link {\r\n    padding: 0;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-item-expandable .nav-item-link span {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar:not(.expanded) .nav-item-group .nav-submenu {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Expanded overlay: restore */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .sidebar.expanded .nav-item-chevron {\r\n    display: flex;\r\n  }\r\n\r\n  .sidebar.expanded .nav-item-expandable .nav-item-link span {\r\n    display: inline;\r\n  }\r\n\r\n  .sidebar.expanded .nav-item-group .nav-submenu {\r\n    display: flex;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
